
import { defineComponent, onMounted, ref } from 'vue'
import axios from 'axios'
import { message } from 'ant-design-vue'
import { Tool } from '@/util/tool'
import { IDrawerProps } from "ant-design-vue/es/vc-drawer/src/IDrawerPropTypes";
import level = IDrawerProps.level;

export default defineComponent({
  name: 'AdminCategory',
  setup() {
    const param = ref()
    // 这里必须设置value 为一个空对象
    param.value = {}
    const categorys = ref()
    const loading = ref(false)

    const columns = [
      {
        title: '名称',
        dataIndex: 'name'
      },
      {
        title: '顺序',
        key: 'sort',
        dataIndex: 'sort'
      },
      {
        title: '父分类',
        dataIndex: 'parent',
        slots: {customRender: 'parent'}
      },
      {
        title: 'Action',
        key: 'action',
        slots: {customRender: 'action'}
      }
    ]

    // 一级分类
    const level1 = ref()

    const handleQuery = () => {
      loading.value = true
      // 如果不清空现有数据，则编辑保存重新加载数据后，再点编辑
      level1.value = []
      axios.get("/category/all").then((response) => {
        loading.value = false
        const data = response.data
        if (data.success) {
          categorys.value = data.content
          console.log('原始数组: ', categorys.value)

          level1.value = []
          level1.value = Tool.array2Tree(categorys.value, 0)
          console.log('树形机构: ', level1.value)
        } else {
          message.error(data.message)
        }
      })
    }

    // 表单
    const category = ref()
    const modalVisible = ref(false)
    const modalLoading = ref(false)
    const handleModalOk = () => {
      modalLoading.value = true
      axios.post("/category/save", category.value).then((response) => {
        modalLoading.value = false
        const data = response.data
        if (data.success) {
          modalVisible.value = false
          modalLoading.value = false
          // 重新加载列表
          handleQuery()
        } else {
          message.error(data.message)
        }
      })
    }

    // 编辑
    const edit = (record: any) => {
      modalVisible.value = true;
      category.value = Tool.copy(record);
    }

    // 新增
    const add = () => {
      modalVisible.value = true;
      // 清空
      category.value = {}
    }

    // 删除
    const handleDelete = (id: number) => {
      axios.delete("/category/delete/" + id).then((response) => {
        const data = response.data
        if (data.success) {
          // 重新加载列表
          handleQuery()
        } else {
          message.error(data.message)
        }
      })
    }

    onMounted(() => {
      handleQuery()
    })

    return {
      param,
      level1,
      // categorys,
      columns,
      loading,
      edit,
      add,
      handleDelete,
      category,
      modalVisible,
      modalLoading,
      handleModalOk,
      handleQuery
    }
  }
})
